(function () {
  if (window.__tdFoodCorner) return;
  window.__tdFoodCorner = true;
  var selectedCategory = 'all';

  function rootFor(node) {
    return node && node.closest ? node.closest('[data-td-food-grid]') : null;
  }

  function optionFor(card) {
    var select = card.querySelector('[data-td-food-variant]');
    if (!select) return null;
    var id = card.getAttribute('data-td-selected-variant-id');
    return Array.from(select.options).find(function (option) { return option.value === id; }) || null;
  }

  function updateCard(card) {
    var root = rootFor(card);
    if (!root) return;
    var option = optionFor(card);
    var dot = card.querySelector('[data-td-variantdot].is-active');
    var source = option || dot;
    var available = source ? source.getAttribute('data-soldout') !== '1' : !!card.querySelector('[data-td-quickadd]');
    var ready = !!(window.TDFoodTiles && window.TDVariantPrompt);
    var button = card.querySelector('[data-td-food-add]');
    if (button) {
      button.disabled = !ready || !available || card.hasAttribute('data-td-food-pending') || !card.querySelector('[data-td-quickadd]');
      button.querySelector('[data-td-food-add-text]').textContent = root.getAttribute(available ? 'data-td-food-add-label' : 'data-td-food-sold-label');
    }
    var heart = card.querySelector('[data-td-wishlist-toggle]');
    if (heart) heart.disabled = !ready;
    var select = card.querySelector('[data-td-food-variant]');
    var confirmed = card.getAttribute('data-td-food-confirmed-variant-id');
    if (select) {
      select.disabled = !ready;
      var picked = card.getAttribute('data-td-user-selected') === '1';
      var pending = select.querySelector('[data-td-food-pending-option]');
      if (option && (confirmed === option.value || (picked && card.getAttribute('data-td-food-secondary') !== '1'))) {
        select.value = option.value;
      } else if (option && picked) {
        if (!pending) {
          pending = document.createElement('option');
          pending.value = 'pending';
          pending.disabled = true;
          pending.hidden = true;
          pending.setAttribute('data-td-food-pending-option', '');
          select.insertBefore(pending, select.options[1] || null);
        }
        pending.textContent = option.getAttribute('data-option1') + ' — ' + root.getAttribute('data-td-food-choice-hint');
        select.value = pending.value;
      } else select.value = '';
      if (pending && select.value !== pending.value) pending.remove();
    }
    var summary = card.querySelector('[data-td-food-selection]');
    if (summary) {
      summary.textContent = '';
    }
    var tag = card.querySelector('[data-td-tag-default]');
    if (tag && source) {
      var price = Number(source.getAttribute('data-price-cents'));
      var compare = Number(source.getAttribute('data-compare-cents'));
      var sale = compare > price;
      var label = sale ? root.getAttribute('data-td-food-sale-label') : card.getAttribute('data-td-food-label');
      var badge = tag.firstElementChild;
      if (!badge && label) {
        badge = document.createElement('div');
        tag.appendChild(badge);
      }
      if (badge) {
        badge.className = 'grid-product__tag ' + (sale ? 'grid-product__tag--sale' : 'grid-product__tag--custom');
        badge.textContent = label || '';
      }
      tag.style.display = available && label ? '' : 'none';
    }
  }

  var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function setGroupOpen(group, expand, animate) {
    var trigger = group.querySelector('[data-td-food-group-toggle]');
    var content = group.querySelector('.td-food__group-content');
    if (!trigger || !content) return;
    if (content.__tdFoodFrame) {
      cancelAnimationFrame(content.__tdFoodFrame);
      content.__tdFoodFrame = 0;
    }
    var alreadyOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (alreadyOpen === expand && animate) return;
    var startHeight = content.getBoundingClientRect().height;
    trigger.classList.toggle('is-open', expand);
    trigger.setAttribute('aria-expanded', String(expand));
    content.classList.toggle('is-open', expand);
    content.toggleAttribute('inert', !expand);
    if (expand && animate) {
      var firstRow = null;
      content.querySelectorAll('.grid-product').forEach(function (card) {
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        if (firstRow === null) firstRow = rect.top;
        var image = card.querySelector('.grid-product__image-mask img');
        if (image && rect.top <= firstRow + 1) {
          image.loading = 'eager';
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'high');
        }
      });
    }
    if (!animate || (reducedMotion && reducedMotion.matches)) {
      content.style.height = expand ? 'auto' : '0px';
      return;
    }
    content.style.height = startHeight + 'px';
    content.offsetHeight;
    var endHeight = expand ? content.scrollHeight : 0;
    content.__tdFoodFrame = requestAnimationFrame(function () {
      content.__tdFoodFrame = 0;
      content.style.height = endHeight + 'px';
    });
  }

  function initFoodAccordion(root) {
    if (root.__tdFoodAccordionReady) return;
    root.__tdFoodAccordionReady = true;
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-td-food-group-toggle]');
      if (!trigger || !root.contains(trigger)) return;
      var group = trigger.closest('[data-td-food-group]');
      if (group) setGroupOpen(group, trigger.getAttribute('aria-expanded') !== 'true', true);
    });
    root.addEventListener('transitionend', function (event) {
      var content = event.target;
      if (event.propertyName !== 'height' || !content.classList.contains('td-food__group-content')) return;
      if (content.classList.contains('is-open')) content.style.height = 'auto';
    });
  }

  function filter(root, key, userAction) {
    var header = document.getElementById('SiteHeader');
    var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var returnToStart = userAction && root.querySelector('.td-food__browse').getBoundingClientRect().bottom < headerBottom;
    root.querySelectorAll('.grid-product__image-mask img[fetchpriority="high"]').forEach(function (image) { image.setAttribute('fetchpriority', 'auto'); });
    root.querySelectorAll('[data-td-food-category-link]').forEach(function (button) { button.setAttribute('aria-pressed', button.getAttribute('data-td-food-category-link') === key ? 'true' : 'false'); });
    var count = 0;
    root.querySelectorAll('[data-td-food-group]').forEach(function (group) {
      group.hidden = key !== 'all' && group.getAttribute('data-td-food-group') !== key;
      if (!group.hidden) count += group.querySelectorAll('[data-td-food-card]').length;
    });
    var multiplePages = Number(root.getAttribute('data-td-food-pages')) > 1;
    var template = root.getAttribute(multiplePages ? 'data-td-food-page-count-label' : 'data-td-food-count-label');
    root.querySelector('[data-td-food-count]').textContent = template.replace('__COUNT__', String(count));
    requestAnimationFrame(function () {
      if (!root.isConnected) return;
      if (userAction) {
        root.querySelectorAll('[data-td-food-group]:not([hidden])').forEach(function (group) {
          setGroupOpen(group, true, false);
        });
      }
      if (returnToStart) root.scrollIntoView({ block: 'start', behavior: 'auto' });
      var firstRow = null;
      root.querySelectorAll('[data-td-food-group]:not([hidden]) .grid-product__image-mask img').forEach(function (image) {
        var rect = image.getBoundingClientRect();
        if (!rect.width) return;
        if (firstRow === null) firstRow = rect.top;
        if (rect.top <= firstRow + 1) {
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'high');
          image.loading = 'eager';
        } else image.setAttribute('fetchpriority', 'auto');
      });
      var nav = root.querySelector('.td-food__category-nav');
      var active = nav && nav.querySelector('[aria-pressed="true"]');
      if (active && (active.offsetLeft < nav.scrollLeft || active.offsetLeft + active.offsetWidth > nav.scrollLeft + nav.clientWidth)) {
        nav.scrollTo({ left: Math.max(0, active.offsetLeft - nav.offsetLeft - 4), behavior: 'auto' });
      }
    });
  }

  var layoutFrame = 0;
  function syncLayout() {
    if (layoutFrame) return;
    layoutFrame = requestAnimationFrame(function () {
      layoutFrame = 0;
      var header = document.getElementById('SiteHeader');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      document.querySelectorAll('[data-td-food-grid], [data-td-browse-grid]').forEach(function (root) {
        var top = Math.round(headerBottom + 8) + 'px';
        if (root.style.getPropertyValue('--td-food-sticky-top') !== top) root.style.setProperty('--td-food-sticky-top', top);
        if (window.TDFoodTiles && window.TDFoodTiles.hintCategory) window.TDFoodTiles.hintCategory(root);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-td-browse-grid]').forEach(initFoodAccordion);
    document.querySelectorAll('[data-td-food-grid]').forEach(function (root) {
      initFoodAccordion(root);
      root.querySelectorAll('[data-td-food-group]').forEach(function (group) {
        var cards = Array.from(group.querySelectorAll('[data-td-food-card]'));
        if (!root.__tdFoodSorted && root.getAttribute('data-td-food-curated') === '1') {
          cards.sort(function (a, b) {
            var rankA = Number(a.getAttribute('data-td-food-rank'));
            var rankB = Number(b.getAttribute('data-td-food-rank'));
            if (root.getAttribute('data-td-food-tet') === '1') {
              if (a.getAttribute('data-td-food-tet-item') === '1') rankA = -1;
              if (b.getAttribute('data-td-food-tet-item') === '1') rankB = -1;
            }
            return rankA - rankB;
          }).forEach(function (card) { group.querySelector('.td-food__cards').appendChild(card); });
        }
        group.querySelector('[data-td-food-group-count]').textContent = root.getAttribute('data-td-food-count-label').replace('__COUNT__', String(cards.length));
      });
      root.__tdFoodSorted = true;
      var select = root.querySelector('[data-td-food-category-select]');
      Array.from(select.options).forEach(function (option) {
        if (option.value === 'all') return;
        if (!root.querySelector('[data-td-food-group="' + option.value + '"]')) option.remove();
      });
      if (!Array.from(select.options).some(function (option) { return option.value === selectedCategory && !option.disabled; })) selectedCategory = 'all';
      select.value = selectedCategory;
      root.querySelectorAll('[data-td-food-card]').forEach(updateCard);
      filter(root, selectedCategory);
    });
    syncLayout();
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-td-food-category-select], [data-td-food-variant]');
    var root = rootFor(select);
    if (!root) return;
    if (select.hasAttribute('data-td-food-category-select')) {
      if (window.TDFoodTiles) window.TDFoodTiles.hideCategoryHint();
      selectedCategory = select.value;
      filter(root, selectedCategory, true);
    } else if (window.TDFoodTiles && select.selectedOptions[0] && select.value) {
      window.TDFoodTiles.select(select.closest('[data-td-food-card]'), select.selectedOptions[0]);
    }
  });

  document.addEventListener('click', function (event) {
    var categoryButton = event.target.closest && event.target.closest('[data-td-food-category-link]');
    if (categoryButton) {
      if (window.TDFoodTiles) window.TDFoodTiles.hideCategoryHint();
      var categoryRoot = rootFor(categoryButton);
      if (!categoryRoot) return;
      selectedCategory = categoryButton.getAttribute('data-td-food-category-link');
      categoryRoot.querySelector('[data-td-food-category-select]').value = selectedCategory;
      filter(categoryRoot, selectedCategory, true);
      return;
    }
    var button = event.target.closest && event.target.closest('[data-td-food-add]');
    if (!button || button.disabled || !window.TDFoodTiles || !window.TDVariantPrompt) return;
    event.preventDefault();
    var card = button.closest('[data-td-food-card]');
    var original = card.querySelector('[data-td-quickadd]');
    if (original && original !== button && !original.disabled && !original.classList.contains('btn--loading')) original.click();
  });

  document.addEventListener('td:food-variant-changed', function (event) { updateCard(event.target); });
  ['collection:reloaded', 'shopify:section:load', 'td:food-tiles-ready', 'td:variant-prompt-ready'].forEach(function (name) { document.addEventListener(name, init); });
  window.addEventListener('pageshow', init);
  window.addEventListener('scroll', syncLayout, { passive: true });
  window.addEventListener('resize', syncLayout, { passive: true });
  window.addEventListener('td:notice-released', syncLayout);
  window.addEventListener('pagehide', function () {
    if (window.TDFoodTiles && window.TDFoodTiles.hideCategoryHint) window.TDFoodTiles.hideCategoryHint();
  });
  window.TDGroupAccordion = { setOpen: setGroupOpen };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

// Clothing: reuse the theme's section renderer, cards, filters and server pagination.
(function () {
  if (window.TDCollectionBrowse || !document.querySelector('[data-td-browse-grid]')) return;
  var rootSelector = '[data-td-browse-grid]';
  var states = new WeakMap();

  function stateFor(root) {
    if (states.has(root)) return states.get(root);
    var config;
    try { config = JSON.parse(root.querySelector('[data-td-browse-config]').textContent); }
    catch (error) { return null; }
    root.querySelectorAll('[data-td-browse-select] option').forEach(function (option) {
      if (config[option.value]) config[option.value].label = option.textContent;
    });
    var section = root.closest('[data-section-type="collection-grid"]');
    if (!section || !config.all) return null;
    var state = { root: root, section: section, config: config, base: root.getAttribute('data-td-browse-path'), key: 'all', params: new URLSearchParams(window.location.search), ticket: 0, cache: [], cards: new Map(), groupOpen: Object.create(null), sidebarHTML: '' };
    state.params.delete('td_category');
    state.params.delete('section_id');
    state.cache.push({ url: state.base + '?section_id=' + section.getAttribute('data-section-id') + '&' + state.params.toString(), html: section.outerHTML, createdAt: Date.now() });
    var sidebar = section.querySelector('#CollectionSidebar');
    if (sidebar) state.sidebarHTML = sidebar.innerHTML;
    states.set(root, state);
    root.querySelector('[data-td-browse-select]').disabled = false;
    root.setAttribute('data-td-browse-ready', '1');
    root.setAttribute('aria-busy', 'false');
    return state;
  }

  function selectedKey(state, params) {
    var key = params.get('td_category') || 'all';
    return Object.prototype.hasOwnProperty.call(state.config, key) ? key : 'all';
  }

  function setControls(state, key) {
    var select = state.root.querySelector('[data-td-browse-select]');
    if (select) select.value = key;
    state.root.querySelectorAll('[data-td-browse-group]').forEach(function (link) {
      link.setAttribute('aria-pressed', String(link.getAttribute('data-td-browse-group') === key));
    });
    var sort = state.root.querySelector('#SortBy');
    if (sort) sort.value = state.params.get('sort_by') || sort.getAttribute('data-default-sortby');
  }

  function busy(state, loading) {
    state.root.setAttribute('aria-busy', String(loading));
    state.root.classList.remove('unload');
    var products = state.root.querySelector('[data-td-browse-products]');
    if (products) products.toggleAttribute('inert', loading);
    state.root.querySelector('[data-td-browse-loading]').hidden = !loading;
    if (loading) state.root.querySelector('[data-td-browse-error]').hidden = true;
  }

  function rememberCards(state) {
    state.root.querySelectorAll('.grid-product[data-product-id][data-td-user-selected="1"]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      state.cards.delete(id);
      state.cards.set(id, card);
    });
    while (state.cards.size > 60) state.cards.delete(state.cards.keys().next().value);
  }

  function preserveCards(state, grid) {
    grid.querySelectorAll('.grid-product[data-product-id]').forEach(function (card) {
      var saved = state.cards.get(card.getAttribute('data-product-id'));
      if (!saved) return;
      var revision = card.getAttribute('data-td-catalog-revision');
      if (revision && revision === saved.getAttribute('data-td-catalog-revision')) {
        if (card.hasAttribute('data-td-browse-index')) saved.setAttribute('data-td-browse-index', card.getAttribute('data-td-browse-index'));
        else saved.removeAttribute('data-td-browse-index');
        card.replaceWith(saved);
      } else state.cards.delete(card.getAttribute('data-product-id'));
    });
  }

  function rememberGroups(state) {
    state.root.querySelectorAll('[data-td-browse-section]').forEach(function (group) {
      state.groupOpen[group.getAttribute('data-td-browse-section')] = group.querySelector('[data-td-food-group-toggle]').getAttribute('aria-expanded') === 'true';
    });
  }

  function prepareGroups(state, grid, key, openSelected) {
    var template = state.root.querySelector('[data-td-browse-section-template]');
    if (key !== 'all' && template) {
      var cards = Array.from(grid.querySelectorAll('.grid-product[data-product-id]')).map(function (card, index) {
        return { card: card, index: Number(card.getAttribute('data-td-browse-index')) || index + 1 };
      }).sort(function (a, b) { return a.index - b.index; });
      var empty = cards.length ? null : grid.querySelector('.grid__item');
      var group = template.content.firstElementChild.cloneNode(true);
      group.setAttribute('data-td-browse-section', key);
      group.setAttribute('data-td-food-group', key);
      var heading = group.querySelector('h2');
      var trigger = group.querySelector('[data-td-food-group-toggle]');
      var content = group.querySelector('.td-food__group-content');
      heading.id = heading.id.replace(/-selection$/, '-' + key);
      content.id = content.id.replace(/-selection$/, '-' + key);
      group.setAttribute('aria-labelledby', heading.id);
      trigger.setAttribute('aria-controls', content.id);
      group.querySelector('.td-food__group-name').textContent = state.config[key].label;
      var total = Number(grid.getAttribute('data-td-browse-count')) || 0;
      var label = cards.length < total ? state.root.getAttribute('data-td-browse-page-count-label').replace('__COUNT__', String(cards.length)) : grid.getAttribute('data-td-browse-count-label');
      if (cards.length === 1 && state.root.hasAttribute('data-td-browse-single-count-label')) label = state.root.getAttribute('data-td-browse-single-count-label');
      group.querySelector('[data-td-food-group-count]').textContent = label;
      var cardGrid = content.firstElementChild;
      cards.forEach(function (entry) { cardGrid.appendChild(entry.card); });
      if (empty) cardGrid.appendChild(empty);
      grid.replaceChildren(group);
      grid.className = 'td-browse__groups';
    }
    grid.querySelectorAll('[data-td-browse-section]').forEach(function (group) {
      var groupKey = group.getAttribute('data-td-browse-section');
      var expand = openSelected || state.groupOpen[groupKey] !== false;
      if (window.TDGroupAccordion) window.TDGroupAccordion.setOpen(group, expand, false);
      state.groupOpen[groupKey] = expand;
    });
  }

  function refreshTheme(state) {
    // These controls persist while results change; fresh nodes prevent duplicate native listeners.
    state.root.querySelectorAll('#SortBy, .js-drawer-open-collection-filters').forEach(function (control) {
      var fresh = control.cloneNode(true);
      if (control.tagName === 'SELECT') fresh.value = control.value;
      control.replaceWith(fresh);
    });
    if (window.theme.sections) window.theme.sections.reinit('collection-grid');
    if (window.theme.reinitProductGridItem) window.theme.reinitProductGridItem();
    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  function settleLayout(state, moveToResults) {
    requestAnimationFrame(function () {
      if (!state.root.isConnected) return;
      var nav = state.root.querySelector('.td-food__category-nav');
      var active = nav && nav.querySelector('[aria-pressed="true"]');
      if (active && (active.offsetLeft < nav.scrollLeft || active.offsetLeft + active.offsetWidth > nav.scrollLeft + nav.clientWidth)) {
        nav.scrollTo({ left: Math.max(0, active.offsetLeft - nav.offsetLeft - 4), behavior: 'auto' });
      }
      var header = document.getElementById('SiteHeader');
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      if (moveToResults && state.root.getBoundingClientRect().top < top) {
        window.scrollTo({ top: Math.max(0, window.scrollY + state.root.getBoundingClientRect().top - top - 8), behavior: 'auto' });
      }
      var firstRow = null;
      state.root.querySelectorAll('[data-td-browse-products] .grid-product__image-mask img').forEach(function (image) {
        var groupContent = image.closest('.td-food__group-content');
        if (groupContent && !groupContent.classList.contains('is-open')) return;
        var rect = image.getBoundingClientRect();
        if (!rect.width) return;
        if (firstRow === null) firstRow = rect.top;
        if (rect.top <= firstRow + 1) {
          image.loading = 'eager';
          image.decoding = 'async';
          image.setAttribute('fetchpriority', 'high');
        }
      });
    });
  }

  function render(root, requested, updateHistory, moveToResults, openSelected) {
    var state = stateFor(root);
    if (!state || !window.theme || !window.theme.AjaxRenderer) return Promise.resolve(false);
    var params = new URLSearchParams(requested);
    var inheritSort = !params.has('td_category');
    // Native filter forms omit the local category; stay in the selected group.
    if (!params.has('td_category') && state.key !== 'all') params.set('td_category', state.key);
    var key = selectedKey(state, params);
    if (key === 'all') params.delete('td_category');
    else params.set('td_category', key);
    var backend = new URLSearchParams(params);
    backend.delete('td_category');
    backend.delete('section_id');
    if (inheritSort && !backend.has('sort_by') && state.params.has('sort_by')) backend.set('sort_by', state.params.get('sort_by'));
    if (backend.has('sort_by')) params.set('sort_by', backend.get('sort_by'));
    var ticket = ++state.ticket;
    var didReplace = false;
    var failed = false;
    var renderer = new window.theme.AjaxRenderer({
      sections: [{ sectionId: state.section.getAttribute('data-section-id'), nodeId: 'CollectionAjaxContent' }],
      onReplace: function (newDom) {
        if (ticket !== state.ticket || !root.isConnected) return;
        var nextGrid = newDom.querySelector('[data-td-browse-products]');
        var currentGrid = root.querySelector('[data-td-browse-products]');
        var nextPagination = newDom.querySelector('[data-td-browse-pagination]');
        var pagination = state.section.querySelector('[data-td-browse-pagination]');
        if (!nextGrid || !currentGrid || !nextPagination || !pagination) throw new Error('Incomplete collection section');
        rememberGroups(state);
        prepareGroups(state, nextGrid, key, openSelected || key !== state.key);
        rememberCards(state);
        preserveCards(state, nextGrid);
        currentGrid.replaceWith(nextGrid);
        pagination.innerHTML = nextPagination.innerHTML;
        var sidebar = state.section.querySelector('#CollectionSidebar');
        var nextSidebar = newDom.querySelector('#CollectionSidebar');
        if (sidebar && nextSidebar) {
          var openFilters = Array.from(sidebar.querySelectorAll('.collapsible-trigger.is-open')).map(function (trigger) { return trigger.getAttribute('data-collapsible-id'); });
          nextSidebar.querySelectorAll('[data-collapsible-id]').forEach(function (element) {
            if (openFilters.indexOf(element.getAttribute('data-collapsible-id')) < 0) return;
            element.classList.add('is-open');
            if (element.classList.contains('collapsible-content--sidebar')) element.style.height = 'auto';
          });
          sidebar.innerHTML = nextSidebar.innerHTML;
          state.sidebarHTML = sidebar.innerHTML;
        }
        root.querySelector('[data-td-browse-count]').textContent = nextGrid.getAttribute('data-td-browse-count-label');
        var badge = root.querySelector('[data-td-browse-filter-count]');
        if (badge) {
          var count = Number(nextGrid.getAttribute('data-td-browse-active-filters')) || 0;
          badge.textContent = String(count);
          badge.hidden = count === 0;
        }
        state.key = key;
        state.params = new URLSearchParams(params);
        setControls(state, key);
        didReplace = true;
      }
    });
    renderer.cachedSections = state.cache.filter(function (entry) { return Date.now() - entry.createdAt < 60000; });
    renderer.getUpdatedParams = function () { return backend; };
    busy(state, true);
    root.querySelector('[data-td-browse-select]').value = key;
    var timeout;
    var timeoutPromise = new Promise(function (_, reject) {
      timeout = setTimeout(function () { reject(new Error('Collection request timed out')); }, 15000);
    });
    return Promise.race([renderer.renderPage(state.config[key].path, backend, false), timeoutPromise]).then(function () {
      if (ticket !== state.ticket) return false;
      if (!didReplace) throw new Error('Missing collection results');
      state.cache = renderer.cachedSections.map(function (entry) {
        if (!entry.createdAt) entry.createdAt = Date.now();
        return entry;
      }).slice(-6);
      if (updateHistory !== false) {
        var query = params.toString();
        var url = state.base + (query ? '?' + query : '') + window.location.hash;
        if (url !== window.location.pathname + window.location.search + window.location.hash) window.history.pushState({}, '', url);
      }
      refreshTheme(state);
      settleLayout(state, moveToResults !== false);
      return true;
    }).catch(function () {
      if (ticket !== state.ticket) return false;
      // Invalidate late responses and restore the last confirmed controls/results.
      state.ticket++;
      failed = true;
      state.retry = { params: params, update: updateHistory, scroll: moveToResults };
      setControls(state, state.key);
      var sidebar = state.section.querySelector('#CollectionSidebar');
      if (sidebar && state.sidebarHTML) sidebar.innerHTML = state.sidebarHTML;
      root.querySelector('[data-td-browse-error]').hidden = false;
      refreshTheme(state);
      return false;
    }).finally(function () {
      clearTimeout(timeout);
      if (ticket === state.ticket || (failed && ticket + 1 === state.ticket)) busy(state, false);
    });
  }

  function choose(root, key) {
    var state = stateFor(root);
    if (!state || !Object.prototype.hasOwnProperty.call(state.config, key)) return;
    if (window.TDFoodTiles) window.TDFoodTiles.hideCategoryHint();
    var params = new URLSearchParams(state.params);
    Array.from(params.keys()).forEach(function (name) {
      if (name === 'page' || name.indexOf('filter.') === 0) params.delete(name);
    });
    // Explicit all is retained until render resolves it, including during a pending request.
    params.set('td_category', key);
    render(root, params, true, true, true);
  }

  function init() {
    document.querySelectorAll(rootSelector).forEach(function (root) {
      if (states.has(root)) return;
      var state = stateFor(root);
      if (!state) return;
      var params = new URLSearchParams(window.location.search);
      var key = selectedKey(state, params);
      if (key !== 'all') render(root, params, false, false);
      else setControls(state, 'all');
    });
  }

  document.addEventListener('click', function (event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target.closest && event.target.closest('[data-td-browse-group], [data-td-browse-retry], [data-td-browse-pagination] a');
    if (!target) return;
    var section = target.closest('[data-section-type="collection-grid"]');
    var root = section && section.querySelector(rootSelector);
    if (!root) return;
    event.preventDefault();
    var state = stateFor(root);
    if (target.hasAttribute('data-td-browse-group')) choose(root, target.getAttribute('data-td-browse-group'));
    else if (target.hasAttribute('data-td-browse-retry')) {
      if (state.retry) render(root, state.retry.params, state.retry.update, state.retry.scroll);
    } else {
      var params = new URLSearchParams(state.params);
      var page = new URL(target.href, window.location.href).searchParams.get('page');
      if (page) params.set('page', page);
      else params.delete('page');
      params.set('td_category', state.key);
      render(root, params, true, true);
    }
  });
  document.addEventListener('change', function (event) {
    var root = event.target.closest && event.target.closest(rootSelector);
    if (root && event.target.hasAttribute('data-td-browse-select')) choose(root, event.target.value);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === ' ' && event.target.matches('[data-td-browse-group]')) { event.preventDefault(); event.target.click(); }
  });
  window.addEventListener('popstate', function () {
    document.querySelectorAll(rootSelector).forEach(function (root) {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('td_category')) params.set('td_category', 'all');
      render(root, params, false, false);
    });
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  window.TDCollectionBrowse = { render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
